export const blogPosts = [
    {
        id: 'introduction-api-netikash',
        slug: 'introduction-api-netikash',
        title: 'Introduction à l\'API Netikash : Votre Guide Complet',
        excerpt: 'Découvrez comment commencer avec l\'API Netikash et intégrer les paiements dans votre application en quelques minutes.',
        author: 'Équipe Netikash',
        date: '2024-03-15',
        category: 'Tutoriel',
        readTime: '5 min',
        image: '/api-hero.jpg',
        featured: true,
        tags: ['API', 'Paiements', 'Tutoriel']
    },
    {
        id: 'securite-api-best-practices',
        slug: 'securite-api-best-practices',
        title: 'Best Practices de Sécurité pour l\'API Netikash',
        excerpt: 'Apprenez les meilleures pratiques pour sécuriser votre intégration API et protéger les données sensibles de vos clients.',
        author: 'Équipe Sécurité',
        date: '2024-03-10',
        category: 'Sécurité',
        readTime: '8 min',
        image: '/security.jpg',
        featured: true,
        tags: ['Sécurité', 'Best Practices', 'API']
    },
    {
        id: 'webhooks-implementation-guide',
        slug: 'webhooks-implementation-guide',
        title: 'Guide Complet : Implémenter les Webhooks Netikash',
        excerpt: 'Un guide étape par étape pour implémenter et tester les webhooks dans votre application.',
        author: 'Équipe Technique',
        date: '2024-03-05',
        category: 'Guide',
        readTime: '10 min',
        image: '/webhooks.jpg',
        featured: false,
        tags: ['Webhooks', 'Intégration', 'Guide']
    },
    {
        id: 'migration-v1-v2',
        slug: 'migration-v1-v2',
        title: 'Migrer de la v1 à la v2 de l\'API Netikash',
        excerpt: 'Tout ce que vous devez savoir pour migrer votre application vers la nouvelle version de l\'API.',
        author: 'Équipe Développement',
        date: '2024-02-28',
        category: 'Migration',
        readTime: '12 min',
        image: '/migration.jpg',
        featured: false,
        tags: ['Migration', 'API', 'Guide']
    },
    {
        id: 'gestion-erreurs-api',
        slug: 'gestion-erreurs-api',
        title: 'Comment Gérer les Erreurs de l\'API Netikash',
        excerpt: 'Découvrez comment gérer efficacement les erreurs API et améliorer l\'expérience utilisateur.',
        author: 'Équipe Support',
        date: '2024-02-20',
        category: 'Tutoriel',
        readTime: '6 min',
        image: '/errors.jpg',
        featured: false,
        tags: ['Erreurs', 'API', 'Tutoriel']
    },
    {
        id: 'optimisation-performance',
        slug: 'optimisation-performance',
        title: 'Optimiser les Performances de Votre Intégration',
        excerpt: 'Conseils et astuces pour améliorer les performances de votre intégration avec l\'API Netikash.',
        author: 'Équipe Performance',
        date: '2024-02-15',
        category: 'Performance',
        readTime: '7 min',
        image: '/performance.jpg',
        featured: false,
        tags: ['Performance', 'Optimisation', 'API']
    }
];

export const categories = ['Tous', 'Tutoriel', 'Sécurité', 'Guide', 'Migration', 'Performance'];